import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import { setLocale } from './lib/i18n';
import registerServiceWorker from './registerServiceWorker';

setLocale(window.navigator.language.slice(0, 2));

ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement,
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx